module.exports = __webpack_public_path__ + "static/media/incomeQualified.23be4846.jpg";